<ion-header>
  <ion-toolbar>
    <ion-title>Balance</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/tecservice-transportec/wallet" color="primary"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="ion-padding ion-text-center">
    <p>Prepago para compra de tickets.</p>
    <h1>{{selected | currency}}</h1>
    <h3>Elige una cantidad</h3>
    <span class="minimum">*mínimo $50</span>
  </div>
  <ion-row>
    <ion-col (click)="select(100)" [class.selected]="selected===100">$100</ion-col>
    <ion-col class="popular" (click)="select(200)" [class.selected]="selected===200">
      <span>Más popular</span>
      $200
    </ion-col>
    <ion-col (click)="select(500)" [class.selected]="selected===500">$500</ion-col>
  </ion-row>
  <ion-row>
    <ion-col (click)="select(1000)" [class.selected]="selected===1000">$1000</ion-col>
    <ion-col (click)="select(2000)" [class.selected]="selected===2000">$2000</ion-col>
    <ion-col (click)="enterOtherAmount()" [class.selected]="otherAmount === true">OTRO</ion-col>
  </ion-row>
  <ion-row *ngIf="otherAmount" hidden>
    <ion-range min="50" max="3000" color="primary" step="10" [(ngModel)]="selected">
      <ion-label slot="start">$50</ion-label>
      <ion-label slot="end">$3000</ion-label>
    </ion-range>
  </ion-row>
</ion-content>
<ion-footer class="ion-padding">
  <ion-button shape="round" fill="outline" color="primary" expand="block" (click)="goPayment()">Continuar</ion-button>
</ion-footer>
